





























































































































































































































































import {
  AuthenticationApi,
  FormsApi,
  PatientApi,
  RefreshAccessTokenRequest
} from "@/api";
import stateMixin from "@/mixins/state";
import moment from "moment";
import {
  subjects,
  who,
  addressLabelFaults,
  crateFaults,
  drugsFaults,
  scrollFaults,
  tdlFaults,
  packageFaults,
  bagFaults,
  otherFaults,
  impact
} from "../../helpers/ImperfectionFormData";

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import { toLocalDateString } from "@/util/date";
// Import the File Type Validation plugin
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  data() {
    return {
      valid: true,
      patientDepartment: null,
      subjects,
      who,
      addressLabelFaults,
      crateFaults,
      drugsFaults,
      scrollFaults,
      tdlFaults,
      packageFaults,
      bagFaults,
      otherFaults,
      impact,
      aboutItems: null,
      imperfectionTypes: [],
      imperfectionTypeId: null,
      myFiles: null,
      faultId: 0,
      dateTime: {
        date: null,
        time: null
      },
      requiredFields: [""],

      errors: {},

      filePond: {
        files: null,
        server: {
          url: process.env.VUE_APP_API,
          process: {
            url: "/api/portal/File/UploadFile",
            method: "POST",
            headers: {
              Authorization: ""
            }
          }
        }
      },

      autocomplete: {
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        error: false
      },

      fields: {
        department: null,
        drugNameAndStrength: null,
        subject: null,
        imperfectionAbout: null,
        generalAdditionalInformation: null,
        imageGuid: null,
        imageExtension: null,
        imageFileType: null,
        imperfectionLocation: null,
        imperfectionTypeInception: null,
        swallowDateTime: null,
        takenActions: null,
        imperfectionImpact: null,
        batchNumber: "M0",
        bagNumber: null
      },

      // Static rules, these fields are always required
      rules: {
        imperfectionLocation: [v => !!v || "Ontdekker is verplicht"],
        imperfectionAbout: [v => !!v || "Wat is de klacht is verplicht"],
        imperfectionTypeInception: [v => !!v || "Klachttype is verplicht"],
        imperfectionImpact: [v => !!v || "Impact is verplicht"],
        department: [v => !!v || "Afdeling is verplicht"]
      },

      startDateMenu: null,
      startTimeMenu: null,
      sendDateMenu: null,
      receiveDateMenu: null,
      toLocalDateString
    };
  },
  name: "ReportImperfectionInceptionOosterwolde",
  mixins: [stateMixin],
  components: {
    FilePond
  },
  methods: {
    submit: async function() {
      this.$refs.form.validate();
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          this.fields.department = this.autocomplete.model.facility;
          const result = await api.formsReportImperfectionInceptionOosterwolde({
            ...this.fields,
            patientId: this.autocomplete.model.patientId,
            swallowDate: this.swallowDateTime
          });
          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch (e) {
          // console.log(e);
          this.errors = {};
          Object.keys(e.response.data.errors).forEach(item => {
            this.errors[item.toLowerCase()] = e.response.data.errors[item];
          });
          this.setState(this.states.ERROR);
        }
      }
    },
    setImperfectionTypes(subject: any) {
      this.imperfectionTypes = subject.fault;
      this.fields.imperfectionAbout = subject.value;
      // Reset any active form validation
      this.$refs.form.resetValidation();
    },
    setImperfectionTypeId(fault: any) {
      // Reset required fields
      this.requiredFields = [""];
      this.imperfectionTypeId = fault.id;
      this.fields.imperfectionTypeInception = fault.value;
      // Keep track of required fields
      this.requiredFields = fault.requiredFields;
      // Reset any active form validation
      this.$refs.form.resetValidation();
    },
    handleFilePondInit() {
      // this.filePond.server.process.headers[
      //   "Authorization"
      // ] = `Bearer ${this.$store.getters["auth/getAuth"].accessToken}`;
    },
    async beforeAddFile() {
      const state = this.$store.getters["auth/getAuth"];
      const api = new AuthenticationApi();
      const request: RefreshAccessTokenRequest = {
        accessToken: state.accessToken,
        refreshToken: state.refreshToken
      };
      const { data } = await api.authenticationRefreshAccessToken(request, {
        transformRequest: (data: any, headers: any) => {
          delete headers.common["Authorization"];
          return data;
        }
      });
      this.$store.dispatch("auth/setAuth", data);
      this.filePond.server.process.headers[
        "Authorization"
      ] = `Bearer ${data.accessToken}`;
      return true;
    },
    processUploadedFile(err, file: FilePondFile) {
      this.fields.imageGuid = file.serverId;
      this.fields.imageExtension = file.fileExtension;
      this.fields.imageFileType = file.fileType;
    },
    getErrors(property: string) {
      const key = property.toLowerCase();
      return this.errors[key] || this.errors[`$.${key}`] || [];
    },
    resetErrors(property: string) {
      const key = property.toLowerCase();
      this.$delete(this.errors, key);
    }
  },
  computed: {
    currentDate() {
      let date = new Date(Date.now());
      return `${date.getFullYear()}-${`0${date.getMonth() + 1}`.slice(
        -2
      )}-${date.getDate()}`;
    },
    swallowDateTime() {
      let date = "";
      if (this.dateTime.date && this.dateTime.time) {
        date = new Date(`${this.dateTime.date} ${this.dateTime.time}`);
      }
      return date ? moment(date).format() : "";
    },
    getValidation: () => {
      return [v => !!v || "Ontdekker is verplicht"];
    },
    patientRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("patientName") > -1
      ) {
        return [v => !!v || "Patient is verplicht"];
      }
      return [];
    },
    swallowDateRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("swallowDate") > -1
      ) {
        return [v => !!v || "Slikdatum is verplicht"];
      }
      return [];
    },
    swallowTimeRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("swallowTime") > -1
      ) {
        return [v => !!v || "Sliktijd is verplicht"];
      }
      return [];
    },
    drugNameAndStengthRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("drugNameAndStrength") > -1
      ) {
        return [v => !!v || "Naam geneesmiddel en sterkte is verplicht"];
      }
      return [];
    },
    batchNumberRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("batchNumber") > -1
      ) {
        return [v => !!v || "Batchnummer is verplicht"];
      }
      return [];
    },
    bagNumberRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("bagNumber") > -1
      ) {
        return [v => !!v || "Nummer zakje is verplicht"];
      }
      return [];
    }
  },
  watch: {
    "autocomplete.search": _.debounce(function(val) {
      if (!val) {
        return;
      }
      if (val.length < 2) {
        return;
      }

      let self = this;
      this.autocomplete.isLoading = true;
      this.autocomplete.error = true;

      const api = new PatientApi();
      api
        .patientSearchPatients({
          filter: val
        })
        .then(function(res) {
          self.autocomplete.entries = res.data;
          self.autocomplete.isLoading = false;
          self.autocomplete.error = false;
        })
        .catch(function(err) {
          self.autocomplete.isLoading = false;
          self.autocomplete.error = true;
        });
    }, 1000)
  }
};
